<template>
  <div class="min-h-screen flex flex-row font-sans">
    <div v-if="!isSideBarNavHidden" class="w-2/6 md:w-1/6">
      <SideBarNav></SideBarNav>
    </div>
    <div :class="[!isSideBarNavHidden ? 'w-4/6 md:w-5/6 overflow-auto' : 'w-full', 'bg-light-blue p-4 md:p-8']">
      <vue-progress-bar></vue-progress-bar>
      <router-view @onAppRun="setSideBarNavStatus($event)" />
    </div>
  </div>
</template>
<script>
import SideBarNav from "./components/SideBarNav.vue";
import userService from "./Services/user.service";

export default {
  components: {
    SideBarNav,
  },
  data() {
    return {
      isSideBarNavHidden: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  methods: {
    setSideBarNavStatus(value) {
      this.isSideBarNavHidden = value;
    },
    getDashBoardSummray() {
      userService.getDashboard().then((response) => {
        this.$store.commit("setInboxCount", response.data.unread_inbox);
        this.$store.commit("setNotificationCount", response.data.unread_notification);
        this.$store.commit("setMemberRequestCount", response.data.new_member_request);
        this.$store.commit("setRequestUpdateCount", response.data.member_request_update);
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");
        }
      });
    },
    getOragnizationProfile() {
      userService.getPorfile().then((response) => {
        this.$store.commit("setHeaderLogo", response.data.data.header_logo);
      });
    },
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "AAA-C Admin Portal";
    },
  },
  created() {
    this.$Progress.start();
  },
  mounted() {
    this.getDashBoardSummray();
    this.getOragnizationProfile();
    this.$Progress.finish();
    if (this.loggedIn) {
      this.$OneSignal.showSlidedownPrompt();
      this.$OneSignal.on("subscriptionChange", (isSubscribed) => {
        if (isSubscribed) {
          this.$OneSignal.getUserId().then((playerId) => {
            localStorage.setItem("player_id", playerId);
            let formData = new FormData();
            formData.append("player_id", playerId);
            userService.storePlayerId(formData);
          });
        }
      });
    }
  },
};
</script>


<style></style>
